import React, { useEffect, useState } from 'react';
import { Modal, Spinner, ModalBody, ModalHeader } from 'reactstrap';

// This component must recieve the openModalErro which is the variable that makes the modal render.
// This component must recieve the onClosed function which is the function that change the variable openModalErro.
// Both openModalErro variable and onClosed function should be defined in the parent component of ModalErro (see Dashboard component).

const ModalErro = ( { openModalErro, title, subtitle, text, onClosed } ) => {

    return (
        <Modal isOpen={openModalErro} toggle={onClosed} centered>
            <div className='d-flex justify-content-between align-items-center pt-3 pr-4 pl-4'>
              <strong className='text-danger'>{title}</strong>
              <strong onClick={onClosed} style={{cursor: "pointer"}}>
                <i className="ri-close-line" />
              </strong>
            </div>
            <ModalBody>
                {subtitle &&
                  <h5>{subtitle}:</h5>
                }
                <p>{text}</p>
            </ModalBody>
        </Modal>
    )
}

export default ModalErro;
